import LDClient, { LDFlagChangeset } from "launchdarkly-js-client-sdk";
import { ThunkAction } from "redux-thunk";
import { camelizeKeys } from "humps";
import { map, prop } from "ramda";
import { LAUNCH_DARKLY_CLIENT_ID } from "constants/app";
import { RequestStatus } from "types/requests";
import { IRootStateProps } from "types/reducers";
import {
  ContextTypeKeys,
  ContextActionTypes,
  ISetFlagStatusAction,
  ISetFlagAction,
  IUpdateFlagAction,
} from "types/context";
import { LDFlags } from "interfaces/context";
import { LDContext } from "launchdarkly-js-sdk-common";

type ContextThunkResult<R> = ThunkAction<
  R,
  IRootStateProps,
  undefined,
  ContextActionTypes
>;

export const initFeatureFlags = (
  permalink: string,
  email: string
): ContextThunkResult<void> => {
  return (dispatch): void => {
    if (permalink) {
      const object: LDContext = {
        kind: "user",
        key: email,
        custom: {
          store_pretty_url: permalink,
        },
      };

      const LD_CLIENT = LDClient.initialize(LAUNCH_DARKLY_CLIENT_ID, object);
      dispatch(setFeatureFlagsStatus(RequestStatus.REQUESTING));

      LD_CLIENT.on("ready", () => {
        const featureFlags = camelizeKeys(LD_CLIENT.allFlags());
        dispatch(setFeatureFlags(featureFlags));
        dispatch(setFeatureFlagsStatus(RequestStatus.SUCCESS));
      });

      LD_CLIENT.on("change", changes => {
        const updatedFlag = camelizeKeys(changes) as LDFlagChangeset;
        dispatch(updateFeatureFlag(map(prop("current"), updatedFlag)));
      });
    }
  };
};

const setFeatureFlags = (flags: LDFlags): ISetFlagAction => ({
  type: ContextTypeKeys.RECEIVE_FEATURE_FLAGS,
  payload: flags,
});

const updateFeatureFlag = (flag: LDFlags): IUpdateFlagAction => ({
  type: ContextTypeKeys.UPDATE_FEATURE_FLAG,
  payload: flag,
});

const setFeatureFlagsStatus = (
  status: RequestStatus
): ISetFlagStatusAction => ({
  type: ContextTypeKeys.SET_REQUEST_STATUS,
  payload: status,
});
